/*
  Beeline UI glue (loaded deferred from layout/theme.liquid).
  - Header "Menu" pill below 900px.
  - Dog vision switch: flips every sticker tile on the page via html[data-bl-dogvision="on"].
    Every switch on the page stays in sync. Reduced motion is handled in CSS (instant swap).
  - Bed color radios: swap the bed image and link to the picked variant.
  - Landing sticky CTA (below 900px): hidden while the main CTA is on screen.
  Delegated listeners, so sections re-rendered by the theme editor keep working.
*/
(() => {
  if (window.BeelineUI) return;
  window.BeelineUI = true;

  const root = document.documentElement;

  const setDogVision = (on) => {
    if (on) root.setAttribute('data-bl-dogvision', 'on');
    else root.removeAttribute('data-bl-dogvision');
    document.querySelectorAll('[data-bl-dv-switch]').forEach((el) => {
      el.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  };

  const closeMenus = (except) => {
    document.querySelectorAll('[data-bl-top].is-open').forEach((top) => {
      if (top === except) return;
      top.classList.remove('is-open');
      const btn = top.querySelector('[data-bl-menu]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const menuBtn = event.target.closest('[data-bl-menu]');
    if (menuBtn) {
      const top = menuBtn.closest('[data-bl-top]');
      const open = !top.classList.contains('is-open');
      closeMenus(top);
      top.classList.toggle('is-open', open);
      menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (!event.target.closest('[data-bl-top]')) closeMenus();

    const dvSwitch = event.target.closest('[data-bl-dv-switch]');
    if (dvSwitch) setDogVision(dvSwitch.getAttribute('aria-checked') !== 'true');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-bl-top].is-open');
    if (!open) return;
    closeMenus();
    const btn = open.querySelector('[data-bl-menu]');
    if (btn) btn.focus();
  });

  document.addEventListener('change', (event) => {
    const radio = event.target.closest('[data-bl-bed] input[type="radio"]');
    if (!radio) return;
    const bed = radio.closest('[data-bl-bed]');
    const images = bed.querySelectorAll('[data-bl-bed-img]');
    const match = bed.querySelector(`[data-bl-bed-img="${CSS.escape(radio.value)}"]`);
    images.forEach((img) => {
      const isDefault = img.getAttribute('data-bl-bed-img') === '';
      img.hidden = match ? img !== match : !isDefault;
    });
    const link = bed.querySelector('[data-bl-bed-link]');
    if (link && radio.dataset.blBedUrl) link.href = radio.dataset.blBedUrl;
  });

  const initStickyCtas = () => {
    if (!('IntersectionObserver' in window)) return;
    document.querySelectorAll('[data-bl-sticky-cta]').forEach((bar) => {
      if (bar.dataset.blStickyReady) return;
      const target = document.getElementById(bar.dataset.blStickyTarget);
      if (!target) return;
      bar.dataset.blStickyReady = 'true';
      new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-hidden', entry.isIntersecting);
      }).observe(target);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyCtas);
  else initStickyCtas();

  // Theme editor: re-sync switches and sticky CTAs in re-rendered sections.
  document.addEventListener('shopify:section:load', () => {
    setDogVision(root.getAttribute('data-bl-dogvision') === 'on');
    initStickyCtas();
  });
})();
